import React from 'react';
import { Modal, Divider, Stack, Button } from '@mantine/core';
import styles from './PopUp.module.css'


type PopUpProps ={
    opened: boolean;
    close: () => void;
    title: string;
    plc_slot?: number;
    onSave: () => void;
    button1?: string;
    button2?: string;
    zIndex?: number;
    size?: number;
    children?: React.ReactNode;
   
}


const PopUp = ({opened, close, title, onSave, button1, button2, zIndex, size, children}: PopUpProps)=> {

    return(
        <Modal zIndex={zIndex} size={size} opened={opened} onClose={close} title={<span className={styles.modalTitle}>{title}</span>}  centered classNames={{
            header: styles.modalHeader,
            body: styles.modalBody,
            content: styles.modalContent,
        }}>
            <Divider my="sm" size={3}  color="black"  className={styles.divider}  />
             <Stack gap="md">
                {children}
                <div className={styles.ButtonContainer}>
                    <Button className={styles.Button} variant="filled" color="#474973" radius="xl" onClick={()=> onSave()}> {button1? button1 : "Save" }</Button>
                    <Button className={styles.Button} variant="outline" color="#474973" radius="xl" onClick={close}> {button2? button2 : "Cancel" } </Button>
                </div>   
            </Stack>
    
       </Modal>
    );

}

export default PopUp